import styled from 'styled-components';
import React from 'react';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
import { getDocs } from 'firebase/firestore';
import { getRevenueRecordsQuery, FilterItem, OrderItem } from 'services';
import { Splash } from 'shared/Components';
import FilterControle from 'shared/Components/FlexebleTable/Components/FilterControle';
import FlexebleTable from 'shared/Components/FlexebleTable/FlexebleTable';

const Icon = styled.img`
  width: 64px;
  height: 64px;
  border-radius: 15px;
  margin-right: 10px;
`;

export const RevenueTable = () => {
  const { date } = useParams<{ date: string }>();

  const [data, setData] = React.useState<any | undefined>();
  const [isLoading, setLoading] = React.useState<boolean>(true);
  const [filters, setFilters] = React.useState<{
    firebase: FilterItem[];
    fields: { [key: string]: any };
  }>({ firebase: [], fields: { createdAt: undefined } });
  const [ordering, setOrdering] = React.useState<OrderItem[]>([]);

  const fetch = async (reset = false) => {
    setLoading(true);
    try {
      const nextQuery = getRevenueRecordsQuery(
        date,
        filters.firebase,
        ordering,
        data?.length > 0 && !reset ? data[data?.length - 1] : undefined,
      );

      const nextData = await getDocs(nextQuery);
      console.log('jesam');
      setData(
        !reset
          ? [...data, ...nextData.docs.filter((doc) => doc.exists())]
          : nextData.docs.filter((doc) => doc.exists()),
      );
    } catch (err) {
      toast.error(`${err}`);
      console.log(err);
    }
    setLoading(false);
  };

  const manageOrdering = (attribute: string) => {
    const orderingItem = ordering.find((item) => item.field === attribute);

    if (orderingItem) {
      if (orderingItem.type === 'asc')
        setOrdering(
          ordering.map((item) => (item?.field === attribute ? { ...item, type: 'desc' } : item)),
        );
      else setOrdering(ordering.filter((item) => item?.field !== attribute));

      return;
    }

    setOrdering([...ordering, { field: attribute, type: 'asc' }]);
  };

  React.useEffect(() => {
    if (isLoading && data) return;
    fetch(true);
  }, [filters.firebase, ordering]);

  React.useEffect(() => {
    console.log('data', data);
  }, [data]);

  return (
    <>
      {data && (
        <>
          <FilterControle
            loading={isLoading}
            onChange={(item) => {
              setFilters({
                firebase: [
                  ...filters.firebase,
                  { attribute: item?.name, value: item?.value, operator: '==' },
                ],
                fields: { ...filters.fields, [item.name]: item },
              });
            }}
            clear={(name: string) => {
              setFilters({
                firebase: filters.firebase.filter((item: any) => item?.attribute !== name),
                fields: { ...filters.fields, [name]: undefined },
              });
            }}
            values={filters.fields}
            keys={[]}
          />
          <FlexebleTable
            onScroll={() => {
              if (!isLoading) fetch();
            }}
            scrollThreshold={30}
            ordering={ordering}
            data={data}
            schema={[
              {
                header: 'Puzzle',
                key: 'puzzle.name',
                mapper: (item) => (
                  <>
                    <Icon src={item?.data()?.puzzle.iconUrl} /> {item?.data()?.puzzle?.name}
                  </>
                ),
                headerClick: () => manageOrdering('puzzle.name'),
                style: {
                  cell: {
                    height: '80px',
                  },
                },
              },
              {
                header: 'Artist',
                key: 'artist.name',
                mapper: (item) => (
                  <>
                    {' '}
                    <Icon src={item?.data()?.artist.profileImageUrl} /> {item?.data()?.artist?.name}
                  </>
                ),
                headerClick: () => manageOrdering('artist.name'),
                style: {
                  cell: {
                    height: '80px',
                  },
                },
              },
              {
                header: 'Country',
                key: 'country',
                mapper: (item) => item?.data()?.country.toUpperCase(),
                headerClick: () => manageOrdering('country'),
                style: {
                  cell: {
                    height: '80px',
                  },
                },
              },
              {
                header: 'Artist Royalties',
                key: 'revenue',
                mapper: (item) => `$${(item?.data()?.revenue ?? 0).toFixed(5)}`,
                headerClick: () => manageOrdering('revenue'),
                style: {
                  cell: {
                    height: '80px',
                  },
                },
              },
              {
                header: 'Revenue',
                key: 'totalRevenue',
                mapper: (item) => `$${item?.data()?.totalRevenue.toFixed(5)}`,
                headerClick: () => manageOrdering('totalRevenue'),
                style: {
                  cell: {
                    height: '80px',
                  },
                },
              },
            ]}
          />
        </>
      )}
      {isLoading && <Splash position="relative" width={64} />}
    </>
  );
};
